import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change (skips in-page #contact anchors).
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
}
